import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})

export class HeaderService {
  
  public statusConection$: Subject<boolean> = new BehaviorSubject(false);  

  // Set the status conection to check if the header counter users, have to be shown
  setStateConection(status: boolean) {
    this.statusConection$.next(status);
  }

  // Set the status conection to check if the header counter users, have to be shown
  getStateConection() {
    return this.statusConection$;
  }

}
